(function ($) {
  $(function() {
    if ($('#edit_plan_offer').length || $('#new_plan_offer').length || $('.show_plan_offer').length) {
      app.helpers.activeMenu('offer_management','offers')
    }
  })
})(jQuery);
